export default __webpack_public_path__ + "images/crack-9jeyZ.png";